import http from './public';
import { Indicator, Toast } from 'mint-ui';
// const baseUrl = '/api';

function GetParam (url, id) {
  url = url+ "";
  let regstr = "/(\\?|\\&)" + id + "=([^\\&]+)/";
  let reg = eval(regstr);
  let result = url.match(reg);

  if (result && result[2]) {
    return result[2];
  }
}

let isTest = GetParam(window.location.href, 'ac')
if (window.location.origin === 'https://gk.zhenzhang.com' || window.location.origin === 'http://gk.zhenzhang.com') {
  isTest = false;
}

let base = localStorage.getItem('cww_url');
if (isTest) { base = '' }
const baseUrl = base || 'http://gk.zhenzhang.com';
export const REQUEST_BASE = () => {
  return baseUrl;
};


// -------------------------------------------------------------------------------
export const CODE_URL = () => {
  return `${baseUrl}/web/index.php?r=api%2Fuser%2Fget-qrcode`;
};
// 测试
export const testUpload = (params) => {
  return http.fetchPost(`http://localhost:3000/upload`, params);
};
// -------------------------------------------------------------------------------

// 登陆
export const userLogin = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fpassport%2Flogin`, params);
};
// 短信接口
export const getMessage = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fuser-hand-binding`, params);
};
// 预报名
export const previewSubmit = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Forder%2Fsubmit-preview`, params);
};
// 专业联动
export const modityLink = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Forder%2Fcommodity-linkage`, params);
};
// 城市联动
export const cityLink = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fdefault%2Fdistrict`, params);
};
// 校区联动
export const campusLink = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Forder%2Fcampus-linkage`, params);
};
// 报名
export const forderSubmit = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Forder%2Fsubmit`, params);
};
// 邀请二维码
export const getQrcode = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fuser%2Fget-qrcode`, params);
};
// 获取推广素材列表
export const getSource = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fpromotional-material`, params);
};
// 生成海报
export const getPoster = (params) => {
  // Indicator.open({ text: '海报生成中...', spinnerType: 'double-bounce' });
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fshare%2Fget-qrcode`, params);
};
// 提现页面数据
export const CashWithdrawal = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fshare%2Fnew-get-info`, params);
};
// 提现
export const CashSubmit = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fshare%2Fapply`, params);
};
// 支付
export const PaymentRelated = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Forder%2Fnew-pay-data`, params);
};
// 资讯列表
export const NoticeList = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchGet(`${baseUrl}/web/index.php?store_id=9&r=api/default/topic-list`, params);
};
// 资讯详情
export const NoticeDetails = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchGet(`${baseUrl}/web/index.php?store_id=9&r=api/default/topic`, params);
};
// 申请助理合伙人
export const applyAssistance = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fapply-assistance`, params);
};
// 人人招生页面信息
export const FuserMsg = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fenroll-mes`, params);
};
// 优惠券领取
export const getCoupon = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?store_id=9&r=api/coupon/receive`, params);
};
// 我的业绩
export const getAchievement = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fmy-achievements`, params);
};
// 团队业绩
export const getAchievements = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fmy-team-achievements`, params);
};
// 我的粉丝
export const getFans = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fmy-fans`, params);
};
// 个人中心
export const getUserInfo = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fget-user-info`, params);
};
// 我的订单
export const getOrderMsg = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Forder%2Fuser-order`, params);
};
// 个人信息页
export const getPersonal = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fuser%2Findex`, params);
}
// 文件上传
export const uploadImg = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=upload%2Fimage`, params);
};
// 个人信息修改
export const changePersonal = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Findex`, params);
};
// 成为粉丝
export const becomefans = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fbecome-fans`, params);
};
// 优惠券列表
export const getCouponList = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fcoupon%2Findex`, params);
};
// 我的团队
export const myTeam = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fmy-team`, params);
};
// 助理合伙人申请列表
export const assistanceList = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fassistance-list`, params);
};
// 助理合伙人处理
export const assistanceAdit = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fapply-assistance-edit`, params);
};
// 邀请人信息
export const inviterInfo = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fuser%2Fget-inviter-info`, params);
};
// 网页配置
export const pageShare = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fget-config`, params);
};
// 教师详情
export const getTeacher = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Fget-teacher`, params);
};
// 地址详情
export const getAddressDetail = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fuser%2Faddress-detail`, params);
};
// 保存地址
export const SaveAddress = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fuser%2Faddress-save`, params);
};
// 提现列表
export const GetCashList = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fshare%2Fcash-detail`, params);
};
// 获取院校
export const GetCollege = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Forder%2Fget-cat`, params);
};
// 预报名表单列表
export const GetTPreview = (params) => {
  Indicator.open({ text: '加载中...', spinnerType: 'double-bounce' });
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fpreview`, params);
}
// 预报名表单信息录入（或编辑）
export const EditMessage = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fpreview-order`, params);
}
// 预报名表单信息删除
export const DeleteMessage = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fpreview-delete`, params);
}
// 搜索推荐人
export const searchInviter = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fsearch-inviter`, params);
}
// 教师端列表(未报名or已报名)
export const teacherForder = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fteacher%2Forder`, params);
}
// 预报名表单二维码生成
export const previewQrcode = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fget-qrcode`, params);
}
// 获取预报名表单信息
export const getPreviewOrder = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fget-preview`, params);
}
// 补充信息
export const teacherSend = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Fteacher%2Fsend`, params);
}
// 订单绑定信息
export const untieOrder = (params) => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Forder%2Funtying`, params);
}
// 订单绑定
export const postUntieOrder = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Forder%2Funtying`, params);
}
// 申请修改推荐人
export const postInviter = (params) => {
  return http.fetchPost(`${baseUrl}/web/index.php?r=api%2Forder%2Finviter-change`, params);
}
// 来源信息
export const getOrigin = () => {
  return http.fetchGet(`${baseUrl}/web/index.php?r=api%2Forder%2Forigin`);
}
